import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import LayoutTemplate from './components/LayoutTemplate';
import About from './pages/About';
import './App.css';

function App() {
  // Header data that will be shared across all pages
  const headerData = {
    title: 'TINEVRA',
    navigation: [
      { label: 'Home', href: '/' },
      { label: 'About', href: '/about' },
      { label: 'Work', href: '/work' },
      { label: 'Contact', href: '/contact' }
    ]
  };

  const HomePage = () => {
    const pageData = {
      // Remove header from here since it's now handled by the main Header component
      hero: {
        title: 'Welcome to TINEVRA',
        subtitle: 'Art & Design Portfolio',
        description: 'Explore creative works that blend art, design, and innovation.',
        backgroundImage: 'https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
        ctaButton: {
          text: 'View Portfolio',
          href: '/portfolio'
        }
      },
      sections: [
        {
          id: 'about',
          type: 'image-text' as const,
          title: 'About TINEVRA',
          content: 'TINEVRA is a creative studio focused on bringing innovative ideas to life through art and design. We believe in the power of visual storytelling and creating meaningful connections through our work.',
          image: 'https://images.unsplash.com/photo-1558655146-d09347e92766?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80'
        },
        {
          id: 'services',
          type: 'cards' as const,
          title: 'Our Services',
          content: 'Digital Art\nWeb Design\nBrand Identity\nIllustration'
        },
        {
          id: 'gallery',
          type: 'gallery' as const,
          title: 'Recent Work',
          images: [
            'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
            'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
            'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80'
          ]
        },
        {
          id: 'contact-banner',
          type: 'full-width-image' as const,
          image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80'
        }
      ],
      footer: {
        text: '© 2024 TINEVRA. All rights reserved.',
        links: [
          { label: 'Privacy', href: '/privacy' },
          { label: 'Terms', href: '/terms' },
          { label: 'Contact', href: '/contact' }
        ]
      }
    };

    return <LayoutTemplate {...pageData} />;
  };

  return (
    <Router>
      <div className="App">
        <Header {...headerData} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;